import React from 'react';

import { LbTabs } from '../LbTabs/LbTabs';
import { LbToggleTabsList } from '../LbToggleTabsList/LbToggleTabsList';
import { DateRangePreset } from '../../../constants/dateRangePreset';
import { dateRangePresetOptions } from './DateRangeFilterTabs.settings';

type DateRangeFilterTabsProps = {
  value: DateRangePreset;
  onValueChange: (value: DateRangePreset) => void;
};

const DateRangeFilterTabs = ({ value, onValueChange }: DateRangeFilterTabsProps) => {
  return (
    <LbTabs value={value} onValueChange={onValueChange}>
      <LbToggleTabsList tabsConfig={dateRangePresetOptions} size="small" />
    </LbTabs>
  );
};

export { DateRangeFilterTabs };
